import { Component, Input, OnInit } from '@angular/core'
import { MatSlideToggleChange } from '@angular/material/slide-toggle'

const ASSET_TYPE_PRODUCT = 'product'

@Component({
    selector: 'app-supplement',
    templateUrl: 'supplement.html'
})
export class SupplementComponent implements OnInit {
    @Input() myFormGroup
    @Input() assetType = ''

    onSlideChanged($event: MatSlideToggleChange) {
        this.changeState('description', $event.checked)
        if (this.assetType !== ASSET_TYPE_PRODUCT) {
            this.changeState('price', $event.checked)
        }
    }

    ngOnInit()  {
        const isEnabled = this.myFormGroup.get('enabled').value
        this.changeState('description', isEnabled)
        if (this.assetType === ASSET_TYPE_PRODUCT) {
            this.changeState('price', false)
        }
    }

    private changeState(field: string, isEnabled: boolean) {
        isEnabled ? this.myFormGroup.get(field).enable() : this.myFormGroup.get(field).disable()
    }

}
